import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import logo from '../../assets/imgs/logoo.svg';
import { FaBars } from 'react-icons/fa';

function Header() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav style={{ backgroundColor: '#e4e4e5' }} className="navbar navbar-expand-lg navbar-light shadow sticky-top p-0">
      <div className="container">
        <a className="navbar-brand p-0" href="#">
          <img src={logo} alt="Logo" width="120" height="80" className="d-inline-block align-text-top me-2 p-0" />
        </a>
        <button className="navbar-toggler" type="button" onClick={toggleSidebar} aria-label="Toggle navigation">
          <FaBars style={{ color: '#01295c', fontSize: '24px' }} />
        </button>
        <div className={`collapse navbar-collapse ${isOpen ? 'show' : ''}`} id="navbarNav">
          <ul className="navbar-nav ms-auto" style={{ fontSize: '1.2rem' }}>
            <li className="nav-item">
              <a className="nav-link" href="#servicos" style={{ color: '#01295c' }}>Serviços</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#mapa" style={{ color: '#01295c' }}>Localização</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#unidades" style={{ color: '#01295c' }}>Unidades</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#faleconosco" style={{ color: '#01295c' }}>Contato</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Header;
